export default __webpack_public_path__ + "static/real-time-data-updates-fe2c3a316cf7191c1cc23c3c05bcfa99.png";